import { FunctionComponent } from 'react';
import styled from 'styled-components';


export const Label = styled.div`
  font-size: 0.75rem;
  font-weight: bold;
  color: #888;
`